export const theme = {
  heading: {
    h5: 'editor-heading-h5',
    h6: 'editor-heading-h6',
  },
  paragraph: 'editor-paragraph',
  text: {
    bold: 'bold-text',
    italic: 'italic-text',
    underline: 'underline-text',
    strikethrough: 'strikethrough-text',
    code: 'code-text',
  },
  list: {
    ol: 'editor-list-ol',
    ul: 'editor-list-ul',
    listitem: 'editor-listItem',
    nested: {
      listitem: 'editor-nestedListItem',
    },
  },
  link: 'editor-link',
  table: 'editor-table',
  tableCell: 'editor-tableCell',
  reference: 'editor-reference',
};
